// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__34-j1","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3inpT"};